module.exports = __webpack_public_path__ + "static/media/arrows.35fcbef7.svg";